import { PennameSection } from './PennameSection'
import { withPennameSection } from './withPennameSection'

const ConnectedPennameSection = withPennameSection(PennameSection)

export { ConnectedPennameSection as PennameSection }
